import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { SESSION_TIMEOUT, IDLE_TIMEOUT, setLastActivity } from "./helpers/lastActivity";
import useAuth from "./hooks/useAuth";
import { useInterval } from "./hooks/useInterval";

interface Props {
	children: React.ReactNode;
}
const promptBeforeIdle = 30000;

const IdleHandler: React.FC<Props> = ({ children }) => {
	const { isLoggedIn, logout, ping } = useAuth();
	const [remaining, setRemaining] = useState<number>(IDLE_TIMEOUT);
	const [open, setOpen] = useState<boolean>(false);
	const onIdle = async () => {
		setOpen(false);
		await logout();
		window.location.href = "/";
	};

	const onPrompt = () => {
		setOpen(true);
	};

	const onActive = () => {
		setOpen(false);
	};

	const { start, getRemainingTime, activate, pause } = useIdleTimer({
		onIdle,
		onPrompt,
		onActive,
		timeout: IDLE_TIMEOUT,
		promptBeforeIdle,
		throttle: 500,
		crossTab: true,
		startOnMount: false,
		startManually: true,
	});

	useInterval(async () => {
		try {
			if (isLoggedIn) {
				await ping();
			}
		} catch (error) {
			console.error(error);
		}
	}, SESSION_TIMEOUT);

	useEffect(() => {
		if (isLoggedIn) {
			start();
		} else {
			pause();
		}

		// eslint-disable-next-line
	}, [isLoggedIn]);

	useEffect(() => {
		const unloadCallback = (event: BeforeUnloadEvent) => {
			setLastActivity();
		};

		window.addEventListener("beforeunload", unloadCallback);
		return () => window.removeEventListener("beforeunload", unloadCallback);
	}, []);

	useInterval(() => {
		setRemaining(Math.ceil(getRemainingTime() / 1000));
	}, 500);

	const handleStillHere = () => {
		activate();
	};

	return (
		<React.Fragment>
			{children}
			<Modal
				open={open}
				closable={false}
				title="Are you still here?"
				footer={[
					<Button
						key="stillHereButton"
						type="primary"
						onClick={handleStillHere}
					>
						Im still here
					</Button>,
				]}
			>
				Logging out in {remaining} seconds
			</Modal>
		</React.Fragment>
	);
};
export default IdleHandler;
